// extracted by mini-css-extract-plugin
export default {"reviewList":"ReviewItemList_reviewList__FaMb5"};